import { DatePicker } from 'antd'
import dateFnsGenerateConfig from 'rc-picker/lib/generate/dateFns'

export const DateFnsDatePicker = DatePicker.generatePicker<Date>(
  dateFnsGenerateConfig,
)
